export default {
  reset(state) {
    state.teachers = [];
    state.selectedTeacher = null;
    state.filter = {};
  },

  updateTeachers(state, payload) {
    state.teachers = payload;
  },

  updateSelectedTeacher(state, teacherId) {
    state.selectedTeacher = teacherId;
  },

  updateFilter(state, payload) {
    state.filter = {...state.filter, ...payload};
  }
};
